import * as $ from "jquery";

export class ImageResizer{
    protected canvas:HTMLCanvasElement;
    protected crop:any;
    constructor(sourceBlob:string, width:number, height: number, cb:Function){
        // NOTE: use uploader canvas!
        this.canvas = $('.uploader_box').find(".canvas")[0] as HTMLCanvasElement;
        this.resize(sourceBlob, width, height,
            () => {
                cb(this.canvas.toDataURL("image/jpeg"));
            }
        );
    }

    protected resize(src: string, w: number, h: number, fg?: Function, first?: any, modify?: string) {
        var img = new Image();
        img.onload = () => {
            if ( this.canvas === undefined) {
                return;
            }
            var x = 0;
            var y = 0;
            var canvas_width:number = img.width;
            var canvas_height:number = img.height;
            //crop center
            if (w !== null && h !== null) {
                if ( this.crop !== undefined ) {
                    if (w === h) { //négyzetes kép esetén, ez egy speckó
                        if (this.crop.align === 'center') {

                            if (img.height < img.width) {
                                if (img.height > h) {
                                    img.width *= h / img.height;
                                    img.height = h;
                                }
                            } else {
                                if (img.width > w) {
                                    img.height *= w / img.width;
                                    img.width = w;
                                }
                            }
                            x = (w - img.width) / 2;
                            y = (h - img.height) / 2;

                            canvas_width = w;
                            canvas_height = h;
                        }else if (this.crop.align === 'top') {

                            if (img.height < img.width) {
                                if (img.height > h) {
                                    img.width *= h / img.height;
                                    img.height = h;
                                }
                            } else {
                                if (img.width > w) {
                                    img.height *= w / img.width;
                                    img.width = w;
                                }
                            }
                            x = (w - img.width) / 2;
                            y = 0;

                            canvas_width = w;
                            canvas_height = h;
                        }
                    }
                } else {
                    // box
                    if (modify === undefined || modify === 'box') {
                        //sima meretezes start
                        if (h > 0 && img.height > h) {
                            img.width *= h / img.height;
                            img.height = h;
                        }
                        if (w > 0 && img.width > w) {
                            img.height *= w / img.width;
                            img.width = w;
                        }
                        canvas_width = img.width;
                        canvas_height = img.height;
                        //sima meretezes end
                    } else if (modify === 'crop') {
                        if (img.height < img.width) {
                            if (img.height > h) {
                                img.width *= h / img.height;
                                img.height = h;
                            }
                        } else {
                            if (img.width > w) {
                                img.height *= w / img.width;
                                img.width = w;
                            }
                        }
                        x = (w - img.width) / 2;
                        y = 0;

                        canvas_width = w;
                        canvas_height = h;
                    } else if (modify === 'crop_top_height') {

                        if (img.width > w) {
                            var new_height = img.height *= w / img.width;
                            if (new_height >= h) {
                                img.height = new_height;
                                img.width = w;
                            }
                        }

                        x = (w - img.width) / 2;
                        y = 0;

                        canvas_width = w;
                        canvas_height = h;
                    }
                }
            } else {
                //original size
                canvas_width = img.width;
                canvas_height = img.height;
            }

            var ctx = this.canvas.getContext("2d");
            //ctx.ImageSmoothingEnabled = false;
            ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

            this.canvas.width = canvas_width;
            this.canvas.height = canvas_height;
            ctx.drawImage(img, x, y, img.width, img.height);
            //watermark place
            // if (watermark_img !== null) {
            //     if (first !== undefined && first === true) {
            //         var wx = img.width - watermark_img.width;
            //         var wy = img.height - watermark_img.height;
            //         ctx.drawImage(watermark_img, wx, wy, watermark_img.width, watermark_img.height);
            //     }
            // }
            if (fg !== undefined) {
                fg();
            }
        };
        img.src = src;
    }

}



// WEBPACK FOOTER //
// ./lib/components/ImageResizer.ts